import './ProfileLayout.scss';

function ProfileLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="profile-page-ui">
      <div className="cs-header-space"></div>
      <div className="cs-container">
        <div className="profile-page-content">
          <div className="profile-content-right">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default ProfileLayout;
